var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 161.9 0 28.2L288 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-135.8L77.4 441.8c-5 4-11.2 6.2-17.6 6.2C44.4 448 32 435.6 32 420.2L32 91.8C32 76.4 44.4 64 59.8 64c6.4 0 12.6 2.2 17.6 6.2L256 215.8 256 80zM64 100.6l0 310.7L254.7 256 64 100.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardStep);
export default __webpack_public_path__ + "static/media/forward-step.1c67bdf46d84ef6073a431568f05b424.svg";
export { ForwardRef as ReactComponent };